import * as React from 'react';

export const LazyRiskChangeNOKExclusion = React.lazy(() => import('./component'));
